import React from 'react';
import MultiSelect from '../MultiSelect';
import { FormHelperText } from "@material-ui/core";
import { getIn } from "formik";
import FormControl from "@material-ui/core/FormControl";

export default function({variant, isClearable, isSearchable, formatOptionLabel, field,form, name,
helperText, error, onChange, label, options, onBlur, displayErrorMessage = true, placeholder, ...otherProps }) {
  const changeHandler = event => {
    form.setFieldValue(field.name, event);
    if (onChange) {
      onChange(event);
    }
  };

  const blurHandler = event => {
    form.setFieldTouched(field.name);
    if (onBlur) {
      onBlur(event);
    }
  };

  const touch = getIn(form.touched, field.name);
  const errorText = getIn(form.errors, field.name);

  return(
      <>
        <FormControl variant="filled">
          <MultiSelect
            {...otherProps}
            options={options}
            name={field.name}
            isMulti
            checkBoxStyled
            value={field.value}
            onChange={changeHandler}
            onBlur={blurHandler}
            formatOptionLabel = {formatOptionLabel}
            isSearchable = {true}
            closeMenuOnSelect={false}
            isClearable = {false}
            textFieldProps={field.value&&field.value.length>0?{ variant:variant, label:''}:{ variant:variant, label :label}}
            placeholder = {field.value&&field.value.length>0?placeholder:""}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }),
            dropdownIndicator: (provided, state) => ({ ...provided, transform: state.selectProps.menuIsOpen && 'rotate(180deg)' }) }}
              error={touch && errorText ? true : false}
            >
          </MultiSelect>
        </FormControl>
          {displayErrorMessage ? (
          <FormHelperText error={Boolean(touch && errorText)}>
            {(touch && errorText) || helperText}
          </FormHelperText>
          ) : (
            helperText && <FormHelperText>{helperText}</FormHelperText>
          )}
      </>
    );

}